// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-flex {
  padding-right: 8px;
  flex: none;
  width: auto;
}

.open-dashboard-btn {
  text-transform: none;
  margin: auto;
  --color: black;
  --border-radius: 30px;
  --border-color: var(--ion-color-secondary);
  min-height: 30px;
  margin-top: 20px;
  width: 180px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu/sidemenu.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AACJ;;AACA;EACI,oBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAEJ","sourcesContent":[".no-flex {\r\n    padding-right: 8px;\r\n    flex: none;\r\n    width: auto;\r\n}\r\n.open-dashboard-btn {\r\n    text-transform: none;\r\n    margin: auto;\r\n    --color: black;\r\n    --border-radius: 30px;\r\n    --border-color: var(--ion-color-secondary);\r\n    min-height: 30px;\r\n    margin-top:20px;\r\n    width: 180px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
